export enum TipoUsuario {
  Executivo =	'1',
  ImportarRelatorio = '2',
  Gerente	= '3',
  Tecnologia = '4',
  Operacional = '5',
  GerenteOperacional = '6',
  Advogado = '7',
  Financeiro = '8',
  GerenteExecutivo = '9',
  Coordenador = '12'
}

const DESCRICAO_TIPO_USUARIO: Record<string, string> = {
  [TipoUsuario.Executivo]: 'Executivo',
  [TipoUsuario.ImportarRelatorio]: 'Importar Relatório',
  [TipoUsuario.Gerente]: 'Gerente',
  [TipoUsuario.Tecnologia]: 'Tecnologia',
  [TipoUsuario.Operacional]: 'Operacional',
  [TipoUsuario.GerenteOperacional]: 'Gerente Operacional',
  [TipoUsuario.Advogado]: 'Advogado',
  [TipoUsuario.Financeiro]: 'Financeiro',
  [TipoUsuario.GerenteExecutivo]: 'Gerente Executivo',
  [TipoUsuario.Coordenador]: 'Coordenador',
};

/** Gerente, tecnologia e coordenador compartilham as mesmas regras. O acesso a telas vem da permissão. */
export function ehPerfilGerencia(tipoUsuario: string | number | null | undefined): boolean {
  const codigo = String(tipoUsuario ?? '').trim();
  return codigo === TipoUsuario.Gerente
    || codigo === TipoUsuario.Tecnologia
    || codigo === TipoUsuario.Coordenador;
}

export function obterDescricaoTipoUsuario(tipoUsuario: string | number | null | undefined): string {
  if (tipoUsuario == null || tipoUsuario === '') {
    return '';
  }
  const codigo = String(tipoUsuario).trim();
  const descricaoDoCadastro = descricaoTipoDoUsuarioLogado(codigo);
  if (descricaoDoCadastro) {
    return descricaoDoCadastro;
  }
  return DESCRICAO_TIPO_USUARIO[codigo]
    || DESCRICAO_TIPO_USUARIO[String(Number(codigo))]
    || '';
}

/** Nome gravado no login, vindo de employeeType. Vale para tipo novo sem alterar o front. */
function descricaoTipoDoUsuarioLogado(codigo: string): string {
  try {
    const tipoLogado = sessionStorage.getItem('tipoUsuario');
    const descricao = (sessionStorage.getItem('tipoUsuarioDescricao') || '').trim();
    if (!descricao || String(tipoLogado ?? '').trim() !== codigo) {
      return '';
    }
    return descricao;
  } catch {
    return '';
  }
}

